import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import { STORE_KEY } from '@/consts';

import loader from '@/components/Loader/store';
import flash from '@/components/FlashMessage/store';
import phone from '@/components/PhoneController/store';
import confirm from '@/components/ConfirmModal/store';

import orderList from '@/views/Order/store';
import paymentReminder from '@/views/PaymentReminder/store';
import contractList from '@/views/ContractList/store';
import contractNew from '@/views/ContractNew/store';
import contractDetail from '@/views/ContractDetail/store';
import contractRenew from '@/views/ContractRenew/store';
import contractRedeem from '@/views/ContractRedeem/store';
import valueAdjustmentList from '@/views/ValueAdjustmentList/store';
import cashLog from '@/views/CashLog/store';
import searchResult from '@/views/SearchResult/store';
import clientList from '@/views/ClientList/store';
import clientDetail from '@/views/ClientDetail/store';
import assetsList from '@/views/Assets/store';

import user from './user';
import app from './app';
import modal from './modal';

Vue.use(Vuex);

const plugins = [];

const vuexPersistLocal = new VuexPersist({
  key: `camdonhanh.${STORE_KEY}`,
  storage: window.localStorage,
  modules: ['user', 'app']
});

const vuexPersistSession = new VuexPersist({
  key: `camdonhanh.${STORE_KEY}`,
  storage: window.sessionStorage,
  modules: ['paymentReminder']
});

plugins.push(vuexPersistLocal.plugin);
plugins.push(vuexPersistSession.plugin);

const store = new Vuex.Store({
  plugins,
  modules: {
    user,
    app,
    phone,
    loader,
    flash,
    modal,
    orderList,
    paymentReminder,
    contractList,
    contractNew,
    contractDetail,
    contractRenew,
    contractRedeem,
    confirm,
    valueAdjustmentList,
    cashLog,
    searchResult,
    clientList,
    clientDetail,
    assetsList,
  }
});

export default store;
